import React from 'react';
import { Box, Typography } from '@mui/material';
import { InfoOutlinedIcon } from 'icons/materialIcons';
import Tooltip from '@mui/material/Tooltip';

const StatContainer = ({ title, value, percentage = 0, trend = 'up', info, hidePercentage = false }) => {
    const renderTrendIndicator = () => {
        if (trend === 'up') {
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', height: '10px', margin: '1px 5px 0 0', marginBottom: '2px' }}>
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="#27AE60" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 0L10 6L0 6L5 0Z" fill="#27AE60" />
                    </svg>
                </Box>
            );
        } else if (trend === 'down') {
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', height: '10px', margin: '1px 5px 0 0', marginBottom: '2px' }}>
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="#EB5757" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 6L10 0L0 0L5 6Z" fill="#EB5757" />
                    </svg>
                </Box>
            );
        }
        return null;
    };

    return (
        <Box
            sx={{
                height: '94px',
                display: 'flex',
                padding: '20px 23px 0px 23px',
                position: 'relative',
                minWidth: '0',
                borderRadius: '18px',
                flexDirection: 'column',
                backgroundColor: '#ffffff',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '5px' }}>
                <Typography
                    sx={{
                        color: '#4F4F4F',
                        fontSize: '12px',
                        fontWeight: 500
                    }}
                >
                    {title}
                </Typography>
                <Tooltip title={info || ''}>
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: '#828282', cursor: 'help' }} />
                </Tooltip>
            </Box>

            <Box sx={{ paddingTop: '10px', display: 'flex', alignItems: 'center' }}>
                <Typography
                    sx={{
                        color: '#000000',
                        fontSize: '26px',
                        fontWeight: 600,
                        marginRight: '10px'
                    }}
                >
                    {value}
                </Typography>
                {!hidePercentage && percentage !== 0 && (
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                        {renderTrendIndicator()}
                        <Typography
                            sx={{
                                fontSize: '12px',
                                fontWeight: 600,
                                color: trend === 'up' ? '#27AE60' : trend === 'down' ? '#EB5757' : '#BDBDBD',
                            }}
                        >
                            {percentage}%
                        </Typography>
                    </Box>
                )}
                {!hidePercentage && percentage === 0 && trend === 'neutral' && (
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                        <svg width="10" height="6" viewBox="0 0 10 6" fill="#BDBDBD" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 0L10 6L0 6L5 0Z" fill="#BDBDBD" />
                        </svg>
                        <Typography
                            sx={{
                                fontSize: '12px',
                                fontWeight: 600,
                                color: '#BDBDBD',
                                marginLeft: '5px'
                            }}
                        >
                            0%
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default StatContainer;